/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Pit1_DInputs */

const en_viewer_pit1_d = /** @type {(inputs: Viewer_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The whole document is parsed and a tree node is built for every value, which costs several times the size of the raw text in memory. A file of a few megabytes is comfortable. Tens of megabytes will make the tab sluggish or run it out of memory, because nothing is streamed or virtualized. For files that big, work on a slice or use a streaming parser locally.`)
};

const ko_viewer_pit1_d = /** @type {(inputs: Viewer_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서 전체를 파싱하고 모든 값마다 트리 노드를 만들므로, 원문 크기의 몇 배에 이르는 메모리를 씁니다. 몇 메가바이트짜리 파일은 편안합니다. 수십 메가바이트가 되면 탭이 느려지거나 메모리가 부족해집니다. 스트리밍이나 가상화를 하지 않기 때문입니다. 그만큼 큰 파일이라면 일부만 잘라서 작업하거나 로컬에서 스트리밍 파서를 쓰세요.`)
};

const ja_viewer_pit1_d = /** @type {(inputs: Viewer_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書全体をパースし、すべての値にツリーノードを作るので、生のテキストの数倍のメモリを使います。数メガバイトのファイルは快適です。数十メガバイトになるとタブが重くなるかメモリが足りなくなります。ストリーミングも仮想化もしていないからです。それほど大きなファイルなら、一部を切り出して作業するか、ローカルでストリーミングパーサを使ってください。`)
};

/**
* | output |
* | --- |
* | "The whole document is parsed and a tree node is built for every value, which costs several times the size of the raw text in memory. A file of a few megabyte..." |
*
* @param {Viewer_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_pit1_d = /** @type {((inputs?: Viewer_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_pit1_d(inputs)
	if (locale === "ko") return ko_viewer_pit1_d(inputs)
	return ja_viewer_pit1_d(inputs)
});